<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <customer-field
          :label="customLabel.pi_custname"
          v-model="form.main.pi_custname"
          @select="onSelectCustomer"
          slot="pi_custname"
        />
        <customer-addr-field
          :label="customLabel.pi_address"
          v-model="form.main.pi_address"
          @select="onSelectAddr"
          :customer-id="form.main.pi_custid"
          v-if="form.main.pi_address"
          slot="pi_address"
        />
        <customer-ct-field
          slot="pi_contact"
          :label="customLabel.pi_contact"
          v-model="form.main.pi_contact"
          :customer-id="form.main.pi_custid"
          v-if="form.main.pi_custname"
        />
        <div class="weui-cell" slot="pi_tel" v-if="form.main.pi_tel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pi_tel || "联系电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">{{ form.main.pi_tel }}</div>
        </div>
        <combo-search-box
          slot="pi_area"
          :label="customLabel.pi_area || '区域'"
          placeholder="请选择或输入区域"
          v-model="form.main.pi_area"
          url="/api/sale/area/getCombo"
          ref="combo"
        />
        <payment-field
          :label="customLabel.pi_payments"
          v-model="form.main.pi_payments"
          @select="onSelectPayment"
          slot="pi_payments"
        />
        <currency-field
          :label="customLabel.pi_currency || '币种'"
          v-model="form.main.pi_currency"
          @select="onSelectCurrency"
          slot="pi_currency"
        />
        <div class="weui-cell" slot="pi_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pi_taxrate || "税率"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.pi_taxrate"
              @change="calcItem()"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="pi_remark">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.pi_remark || "备注"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.pi_remark"
                placeholder="备注"
              />
            </div>
        </div>
        <custom-field 
          :label="customLabel.pi_text1 || '自定义字段1'"
          v-model="form.main.pi_text1" :caller="caller" fieldName="pi_text1"
          slot="pi_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.pi_text2 || '自定义字段2'"
          v-model="form.main.pi_text2" :caller="caller" fieldName="pi_text2"
          slot="pi_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text3 || '自定义字段3'"
          v-model="form.main.pi_text3" :caller="caller" fieldName="pi_text3"
          slot="pi_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text4 || '自定义字段4'"
          v-model="form.main.pi_text4" :caller="caller" fieldName="pi_text4"
          slot="pi_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.pi_text5 || '自定义字段5'"
          v-model="form.main.pi_text5" :caller="caller" fieldName="pi_text5"
          slot="pi_text5" hidden="true"
        />
        <file-field v-model="form.main.pi_attach" slot="pi_attach" hidden="true" />
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <custom-layout
          class="weui-cells"
          :view-config="customViewConfig"
          position="detail1"
        >
          <div class="weui-cell" slot="pd_pocode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pd_pocode || "客户PO号"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.pd_pocode"
                placeholder="请输入"
              />
            </div>
          </div>
          <div class="weui-cell" slot="pd_custprodcode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pd_custprodcode || "客户料号"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.pd_custprodcode"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="sd_prodcode" v-if="item.productDTO.pr_code">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.sd_prodcode || "产品编号"
              }}</label>
            </div>
            <div class="weui-cell__bd">{{ item.productDTO.pr_code }}</div>
          </div>
          <product-field
            slot="pr_detail"
            :label="customLabel.pr_detail"
            v-model="item.productDTO.pr_detail"
            @select="onSelectProduct($event, item)"
          />
          <div
            class="weui-cell"
            slot="pr_orispeccode"
            v-if="item.productDTO.pr_orispeccode"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              {{ item.productDTO.pr_orispeccode }}
            </div>
          </div>
          <warehouse-field
            slot="pd_whname"
            v-model="item.pd_whname"
            @select="onSelectWarehouse($event, item)"
            :label="customLabel.pd_whname || '仓库'"
          />
          <div class="weui-cell" slot="pr_spec" v-if="item.productDTO.pr_spec">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pr_spec || "规格"
              }}</label>
            </div>
            <div class="weui-cell__bd">{{ item.productDTO.pr_spec }}</div>
          </div>
          <div class="weui-cell" slot="pd_outqty">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pd_outqty || "数量"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.pd_outqty"
                @change="calcItem(item)"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{ item.productDTO.pr_unit }}</div>
          </div>
          <div class="weui-cell" v-if="item.productDTO.pr_unit_extra">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                "辅助数量"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                :value="$number.round(item.pd_outqty / item.productDTO.pr_denominator * item.productDTO.pr_numerator || 0, 3)"
                @input="oninputQty($event, item)"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{ item.productDTO.pr_unit_extra }}</div>
          </div>
          <div class="weui-cell" slot="pd_netprice">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pd_netprice || "不含税单价"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.pd_netprice"
                @change="calcItem(item)"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="pd_netprice" v-if="item.pd_netprice">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pd_nettotal || "不含税金额"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              {{ numberFormat(item.pd_nettotal,'¥#,##0.00') }}
            </div>
          </div>
          <div class="weui-cell" slot="pd_remark">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.pd_remark || "备注"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.pd_remark"
                placeholder="备注"
              />
            </div>
          </div>
          <custom-field 
            :label="customLabel.pd_text1 || '自定义字段1'"
            v-model="item.pd_text1" :caller="caller" fieldName="pd_text1"
            slot="pd_text1" hidden="true"
          />
          <custom-field
            :label="customLabel.pd_text2 || '自定义字段2'"
            v-model="item.pd_text2" :caller="caller" fieldName="pd_text2"
            slot="pd_text2" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text3 || '自定义字段3'"
            v-model="item.pd_text3" :caller="caller" fieldName="pd_text3"
            slot="pd_text3" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text4 || '自定义字段4'"
            v-model="item.pd_text4" :caller="caller" fieldName="pd_text4"
            slot="pd_text4" hidden="true"
          />
          <custom-field 
            :label="customLabel.pd_text5 || '自定义字段5'"
            v-model="item.pd_text5" :caller="caller" fieldName="pd_text5"
            slot="pd_text5" hidden="true"
          />
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </custom-layout>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import CustomerAddrField from "@/components/field/CustomerAddrField.vue";
import CustomerCtField from "@/components/field/CustomerCtField.vue";
import PaymentField from "@/components/field/PaymentField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import ComboSearchBox from "@/components/field/ComboSearchBox.vue";
import ProductField from "@/components/field/ProductField.vue";
import WarehouseField from "@/components/field/WarehouseField.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";
import FileField from "@/components/field/FileField.vue";

export default {
  components: {
    CustomLayout,
    CustomerField,
    CustomerAddrField,
    CustomerCtField,
    PaymentField,
    CurrencyField,
    ComboSearchBox,
    WarehouseField,
    ProductField,
    CustomField,
    FileField
  },
  mixins: [process],
  props: {
    itemData: Object,
  },
  data() {
    return {
      baseUrl: "/api/sale/prodinout",
      codeField: "pi_inoutno",
      statusField: "pi_statuscode",
      caller: "SaleOut",
      xtype: "sale-saleout-formpanel",
      form: {},
    };
  },
  methods: {
    /**
     * 选择客户
     */
    onSelectCustomer(selection) {
      var me = this,
        main = me.form.main;
      main.pi_custid = selection.id;
      main.pi_custcode = selection.cu_code;
      main.pi_address = selection.ca_address;
      main.pi_sellercode = selection.cu_sellercode;
      main.pi_seller = selection.cu_sellername;
      main.pi_sellerid = selection.cu_sellerid;
      main.pi_currency = selection.cu_currency;
      main.pi_rate = selection.cr_rate;
      main.pi_contact = selection.cc_name;
      main.pi_tel = selection.cc_tel;
      main.pi_paymentsid = selection.cu_paymentsid;
      main.pi_paymentscode = selection.cu_paymentscode;
      main.pi_payments = selection.cu_payments;
      main.pi_taxrate = selection.cu_taxrate;
    },
    onSelectAddr(selection) {
      var me = this,
        main = me.form.main;
      main.pi_address = selection.value
    },
    /**
     * 选择收款方式
     */
    onSelectPayment(selection) {
      var me = this,
        main = me.form.main;
      main.pi_paymentsid = selection.id;
      main.pi_paymentscode = selection.pa_code;
    },
    /**
     * 选择币种
     */
    onSelectCurrency(selection) {
      var me = this,
        main = me.form.main;
      main.pi_rate = selection.cr_rate;
    },
    /**
     * 选择明细产品
     */
    onSelectProduct(selection, item) {
      item.pd_prodid = selection.id;
      item.pd_prodcode = selection.pr_code;
      item.productDTO = Object.assign({}, selection);
    },
    /**
     * 选择仓库
     */
    onSelectWarehouse(selection, item) {
      item.pd_whid = selection.id;
      item.pd_whcode = selection.wh_code;
    },
    /**
     * 计算单价、金额
     */
    calcItem(selection) {
      var me = this,
        main = me.form.main,
        tr = main.pi_taxrate || 0,
        items = selection ? [selection] : me.form.items;
      items.forEach((item) => {
        item.pd_outqty = me.$number.round(item.pd_outqty || 0, 3);
        item.pd_netprice = me.$number.round(item.pd_netprice || 0, 6);
        item.pd_nettotal = me.$number.round(item.pd_outqty * item.pd_netprice, 2);
        item.pd_price = me.$number.round(item.pd_netprice * (1 + tr / 100), 6);
        item.pd_total = me.$number.round(item.pd_outqty * item.pd_price, 2);
        item.pd_taxamount = item.pd_total - item.pd_nettotal;
      });
    },
    /**
     * 输入辅助数量
     */
    oninputQty(e, item) {
      item.pd_outqty = e.target.value / item.productDTO.pr_numerator * item.productDTO.pr_denominator
      this.calcItem(item)
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.pi_custname) {
        me.$weui.topTips("请选择客户", 2000);
      } else if (!main.pi_currency) {
        me.$weui.topTips("请选择币种", 2000);
      } else {
        main.pi_taxrate = main.pi_taxrate || 0;
        var count = 0,
          total = 0,
          nettotal = 0,
          tax = 0;
        items.forEach(function (item) {
          if (!item.pd_prodid) {
            me.$weui.topTips(`第${count + 1}行产品未选择`, 2000);
            return false;
          } else if (!item.pd_outqty || item.pd_outqty <= 0) {
            me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
            return false;
          } else {
            count++;
            item.pd_pdno = count;
            item.pd_taxrate = main.pd_taxrate;
            // 合计
            total += item.pd_total;
            nettotal += item.pd_nettotal;
            tax += item.pd_taxamount;
          }
        });
        checked = count == items.length;
        main.pi_total = total;
        main.pi_nettotal = nettotal;
        main.pi_taxtotal = tax;
      }

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        pd_qty: 0,
        pd_netprice: 0,
        pd_nettotal: 0,
        pd_price: 0,
        pd_total: 0,
        pd_taxamount: 0,
        productDTO: {},
      });
    },
  },
};
</script>